import { Container, Box, Heading } from '@hover/blueprint';
import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { Link as GatsbyLink } from 'gatsby';
import ArrowButton from '../../ui/ArrowButton';

interface Props {
  backgroundColor: string;
}

const ReadyToStartMobile: React.FC<Props> = ({ backgroundColor }) => (
  <Container
    flexDir="column"
    alignItems="center"
    d={{ base: 'flex', desktop: 'none' }}
    bg={backgroundColor}
    borderRadius="8px"
    w="100%"
    pt={700}
  >
    <Heading color="neutral.0" size={500} isLight textAlign="center">
      Ready to get started?
    </Heading>
    <Heading
      color="neutral.0"
      size={200}
      isDisplay
      textAlign="center"
      marginBottom={0}
    >
      All about how HOVER helps you get the job done.
    </Heading>
    <ArrowButton
      as={GatsbyLink}
      to={`${process.env.GATSBY_V2_PREFIX}/how-it-works`}
      display="block"
      colorScheme="primary"
      type="button"
      w={{ base: '100%', tablet: 'auto' }}
      my={700}
    >
      LEARN MORE
    </ArrowButton>
    <Box alignItems="center">
      <StaticImage
        quality={100}
        placeholder="blurred"
        alt="phone"
        height={370}
        src="../../../assets/images/want_to_learn_more_phone.png"
      />
    </Box>
  </Container>
);

export default ReadyToStartMobile;
